import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const ProgramDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsProgramDetails" */ 'modules/activityDetails/ProgramDetails/pages/ProgramDetails'
    )
)

const ProgramDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:programId`} component={ProgramDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default ProgramDetailsRouting
